import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Trans from "atoms/i18n/trans";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { t } from "utilities/localization-utils";

const BASE_CLASS_NAME = "c-notebook-call-to-action";

interface NotebookCallToActionProps {
    onCreatePageClick: () => void;
    onDismiss: () => void;
}

const NotebookCallToAction: React.FC<NotebookCallToActionProps> = ({
    onCreatePageClick,
    onDismiss,
}) => {
    return (
        <div className={BASE_CLASS_NAME}>
            <div className={`${BASE_CLASS_NAME}__content`}>
                <Heading cssClassName={`${BASE_CLASS_NAME}__heading`}>
                    {t("getStarted")}
                </Heading>
                <Paragraph>
                    <Trans i18nKey={"notebooks-get-started-info"}>
                        Begin by adding text, creating checklists, or uploading
                        images to create your page content. Add code snippets,
                        which you can highlight and annotate, to your page via
                        the <strong>Reference Panel</strong>
                        (right panel), and organize your pages via the
                        <strong>Notebooks panel</strong> (left panel).
                    </Trans>
                </Paragraph>
                <div className={`${BASE_CLASS_NAME}__buttons`}>
                    <Button
                        cssClassName={`${BASE_CLASS_NAME}__create-page-button`}
                        onClick={onCreatePageClick}>
                        {t("notebooks-create-new-page")}
                    </Button>
                    <Button
                        cssClassName={`${BASE_CLASS_NAME}__dismiss-button`}
                        onClick={onDismiss}
                        style={ButtonStyles.Secondary}>
                        {t("ok-gotIt")}
                    </Button>
                </div>
            </div>
            <div className={`${BASE_CLASS_NAME}__create-page-info`}>
                <Icon
                    type={Icons.File}
                    size={IconSizes.XLarge}
                    cssClassName={`${BASE_CLASS_NAME}__page-icon`}
                />
                <Paragraph
                    cssClassName={`${BASE_CLASS_NAME}__create-page-info__text`}>
                    <Trans i18nKey={"notebooks-create-new-page-info"}>
                        Start from a blank <strong>Page</strong>
                    </Trans>
                </Paragraph>
                <Button
                    onClick={onCreatePageClick}
                    style={ButtonStyles.Secondary}>
                    {t("notebooks-create-new-page")}
                </Button>
            </div>
        </div>
    );
};

export default NotebookCallToAction;
